import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'stxt-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {}
